// extracted by mini-css-extract-plugin
export default {"container":"AdminLoginSSO_container__pt0dv","sign-in":"AdminLoginSSO_sign-in__qd7YY","text":"AdminLoginSSO_text__BtXWF","button":"AdminLoginSSO_button__+Z+-V"};